import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { Response } from "src/app/shared/models/Response";
import { Observable } from "rxjs";
import { PagedResponse } from "../shared/models/PagedResponse";
import { Page } from "../shared/models/Page";
import { Alerta } from "../models/Alertas/Alerta";
import { AlertaFilter } from "../models/Alertas/AlertaFilter";
import { AlertaUsuariosRequest } from "../models/Alertas/alertaUsuarios";
import { Usuario } from "../models/Usuario/Usuario";
import { UsuarioFilter } from "../models/Usuario/UsuarioFilter";

@Injectable({
	providedIn: "root",
})
export class AlertaService {
	private REST_API_SERVER = environment.backend_server + "/Alerta";

	constructor(private http: HttpClient) {}

	public getDataByPage(filtro: AlertaFilter, page: Page): Observable<PagedResponse<Alerta>> {
		return this.http.get<PagedResponse<Alerta>>(this.REST_API_SERVER + "/list/filter?Nombre=" + (filtro.nombre != undefined ? filtro.nombre : "") + "&EmisorId=" + (filtro.emisorId != undefined ? filtro.emisorId : "") + "&UsuarioId=" + (filtro.usuarioId != undefined ? filtro.usuarioId : "") + "&Activo=" + filtro.activo + "&pageNumber=" + page.pageNumber + "&pageSize=" + page.pageSize);
	}
	public getUsuarioDataByPage(filtro: UsuarioFilter, page: Page): Observable<PagedResponse<Usuario>> {
		return this.http.get<PagedResponse<Usuario>>(
			this.REST_API_SERVER + "/userList/filter?Nombre=" + (filtro.nombre != undefined ? filtro.nombre : "") + "&Rut=" + (filtro.rut != undefined ? filtro.rut : "") + "&UsuarioId=" + (filtro.usuarioId != undefined ? filtro.usuarioId : "") + "&Comuna=" + (filtro.comuna != undefined ? filtro.comuna : "") + "&Activo=" + filtro.activo + "&EmisorId=" + (filtro.emisorId != undefined ? filtro.emisorId : "") + "&pageNumber=" + page.pageNumber + "&pageSize=" + page.pageSize
		);
	}

	updateAlertUsers(request: AlertaUsuariosRequest): Observable<Response<boolean>> {
		return this.http.post<Response<boolean>>(this.REST_API_SERVER + "/updateAlertUsers", request);
	}
	updateAlert(request: Alerta): Observable<Response<boolean>> {
		return this.http.post<Response<boolean>>(this.REST_API_SERVER + "/updateAlert", request);
	}
}
